import React from 'react';
// import Collections from '../../Pages/Collections/Collections';
import Collections from '../../Pages/Collections/Collections.Page';
import { Navigate, Route, Routes } from 'react-router-dom';
import AddCategory from '../../Pages/AddCategory/AddCategory.Page';
import EditCategory from '../../Pages/EditCategory/EditCategory.Page';
import Category from '../../Pages/Category/Category.Page';
import CollectionProducts from '../../Pages/CollectionProducts/CollectionProducts.Page';
import AddCollection from '../../Pages/AddCollection/AddCollection.Page';
import { CollectionFormContextProvider } from '../../Context/CollectionFormContext';
import EditCollection from '../../Pages/EditCollection/EditCollection.Page';
import CustomCollectionProducts from '../../Pages/CustomCollectionProducts/CustomCollectionProducts.Page';
import AddCustomCollection from '../../Pages/AddCustomCollection/AddCustomCollection.Page';
import { CategoryCollectionContextProvider } from '../../Context/Collections/CategoryCollectionContext';
import EditCustomCollection from '../../Pages/EditCustomCollection/EditCustomCollection.Page';

function CollectionsRoute() {
    return (
        <Routes>
            <Route index element={<Collections />} />

            <Route path='categories'>
                <Route index element={<Navigate to="/collections" replace />} />

                <Route path='add-category' element={<AddCategory />} />

                <Route path='edit-category'>
                    <Route index element={<Navigate to="/collections" replace />} />

                    <Route path=':categoryId' element={<EditCategory />} />
                </Route>

                <Route path=':categoryId'>
                    <Route index 
                        element={
                            <CategoryCollectionContextProvider>
                                <Category />
                            </CategoryCollectionContextProvider>
                        } 
                    />

                    <Route path='collection'>
                        <Route index element={<Navigate to=".." replace />} />

                        <Route path=':collectionId' element={<CollectionProducts />} />

                        <Route path='add-collection' 
                            element={
                                <CollectionFormContextProvider>
                                    <AddCollection />
                                </CollectionFormContextProvider>
                            }
                        />

                        <Route path='edit-collection'>
                            <Route index element={<Navigate to="../.." replace />} />

                            <Route path=':collectionId' 
                                element={
                                    <CollectionFormContextProvider>
                                        <EditCollection />
                                    </CollectionFormContextProvider>
                                }
                            />
                        </Route>
                    </Route>
                </Route>
            </Route>

            <Route path='custom-collections'>
                <Route index element={<Navigate to="/collections" replace />} />

                <Route path=':customCollectionId' element={<CustomCollectionProducts />} />

                <Route path='add-custom-collection' 
                    element={
                        <CollectionFormContextProvider>
                            <AddCustomCollection />
                        </CollectionFormContextProvider>
                    }
                />

                <Route path='edit-custom-collection'>
                    <Route index element={<Navigate to="/collections" replace />} />

                    <Route path=':customCollectionId' 
                        element={
                            <CollectionFormContextProvider>
                                <EditCustomCollection />
                            </CollectionFormContextProvider>
                        }
                    />
                </Route>
            </Route>
        </Routes>
    );
}

export default CollectionsRoute;
